import { Check, AlertTriangle } from 'lucide-react'
import type { ProjectStatus } from '../StatusBadge/index'
import styles from './StatusTimeline.module.css'

export interface StatusTimelineProps {
  status: ProjectStatus
}

interface Step {
  id: ProjectStatus | 'in_review'
  label: string
  sublabel?: string
}

const STEPS: Step[] = [
  { id: 'uploaded', label: 'Hochgeladen' },
  { id: 'in_review', label: 'In Prüfung' },
  { id: 'analysis_in_progress', label: 'Analyse' },
  { id: 'results_available', label: 'Ergebnis' },
]

function stepIndex(status: ProjectStatus): number {
  switch (status) {
    case 'uploaded': return 0
    case 'action_needed': return 0
    case 'in_review': return 1
    case 'analysis_in_progress': return 2
    case 'results_available': return 3
  }
}

export function StatusTimeline({ status }: StatusTimelineProps) {
  const activeIdx = stepIndex(status)
  const isActionNeeded = status === 'action_needed'

  return (
    <div className={styles.timeline}>
      {STEPS.map((step, idx) => {
        const isCompleted = idx < activeIdx
        const isActive = idx === activeIdx
        const isWarning = isActive && isActionNeeded

        let dotClass = styles.dot
        if (isCompleted) dotClass = `${styles.dot} ${styles.dotCompleted}`
        else if (isWarning) dotClass = `${styles.dot} ${styles.dotWarning}`
        else if (isActive) dotClass = `${styles.dot} ${styles.dotActive}`

        let labelClass = styles.label
        if (isActive && !isWarning) labelClass = `${styles.label} ${styles.labelActive}`
        if (isWarning) labelClass = `${styles.label} ${styles.labelWarning}`
        if (isCompleted) labelClass = `${styles.label} ${styles.labelCompleted}`

        return (
          <div key={step.id} className={styles.step}>
            <div className={dotClass}>
              {isCompleted && <Check size={12} strokeWidth={3} />}
              {isWarning && <AlertTriangle size={11} strokeWidth={2.5} />}
              {!isCompleted && !isWarning && (
                <span className={styles.stepNum}>{idx + 1}</span>
              )}
            </div>
            {idx < STEPS.length - 1 && (
              <div className={[styles.connector, isCompleted ? styles.connectorFilled : ''].join(' ')} />
            )}
            <span className={labelClass}>
              {step.label}
              {isWarning && <span className={styles.warningNote}>Aktion erforderlich</span>}
            </span>
          </div>
        )
      })}
    </div>
  )
}
